import * as $ from 'jquery';
import { YoutubeService } from '../../page-services/youtube-service';

export class YoutubeFrontend {
    static init() {
        setTimeout(() => {
            YoutubeService.updateLayout();
            $('.youtube-root').animate({ opacity: 1 }, 300);
        }, 2000);
    }
}